
// Step 4: Creates a force-directed graph using d3.js that displays the json
function createForceDirectedGraph(data) {

  const container = d3.select("#diagram-container");
  containerWidth = container.node().getBoundingClientRect().width;
  containerHeight = container.node().getBoundingClientRect().height;

  svg = d3.select('#diagram')
    .append('svg')
    .attr('width', width)
    .attr('height', height);

// set the size of the arrowheads
var markerWidth = nodeRadius / 2;
var markerHeight = nodeRadius / 2;
//var markerWidth = nodeRadius ;
//var markerHeight = nodeRadius;

// create the arrowhead markers
svg.append("defs").selectAll("marker")
  .data(["arrowhead"])
  .enter().append("marker")
  .attr("id", function(d) { return d; })
  .attr("viewBox", "0 -5 10 10")
  .attr("refX", nodeRadius + markerWidth + 10)
  .attr("refY", 0)
  .attr("markerWidth", markerWidth)
  .attr("markerHeight", markerHeight)
  .attr("orient", "auto")
  .append("path")
  .attr("d", "M0,-5L10,0L0,5");


  simulation = d3.forceSimulation(data.nodes)
    .force('link', d3.forceLink(data.links).id(d => d.id).distance(100))
    //.force('charge', d3.forceManyBody().strength(50)) // add force to push nodes apart
    .force('charge', d3.forceManyBody().strength(-300)) // add force to push nodes apart
    .force('center', d3.forceCenter(width / 2, height / 2)) // center the graph
    .force('collide', d3.forceCollide().radius(function(d) { return d.radius + 50; })// add force to prevent circles from overlapping
    //.force('extent', d3.forceExtent([[0, 0], [width, height]]))
    .iterations(5)
    .strength(100)); 


  link = svg.selectAll('.link')
    .data(data.links)
    .enter()
    .append('line')
    .attr('class', 'link')
    .attr('stroke', 'gray')
    .attr('stroke-width', d => Math.sqrt(d.value))
    .attr('marker-end', 'url(#arrowhead)') // add arrowhead to link
    .attr("x1", function(d) { return d.source.x + nodeRadius; })
    .attr("y1", function(d) { return d.source.y - nodeRadius; })
    .attr("x2", function(d) { return d.target.x - nodeRadius; })
    .attr("y2", function(d) { return d.target.y + nodeRadius; });


  node = 
    svg.selectAll('.node')
    .data(data.nodes)
    .enter()
    .append('g')
    .append('circle')
    .attr('class', 'node')
    .attr('r', nodeRadius)
    .attr('stroke', 'green') // add a visible outline
    .attr('stroke-width', 2) // specify the outline width
    //.attr('fill', d => `rgb(${d.group * 60}, 100, 200)`)
    //.attr('fill', d => `white`, 100, 200)
    .attr('fill', d => `rgba(255, 255, 255, 0.5`)
    // .call(dragNode)
      .on("dblclick", function(d) { // toggle freeze on double click
        d.fixed = !d.fixed;
        d3.select(this).classed("fixed", d.fixed);
        if (d.fixed) {
            d.fx = d.x;
            d.fy = d.y;
        } else {
            d.fx = null;
            d.fy = null;
        }
    })
    .call(d3.drag()
      .on('start', dragstarted)
      .on('drag', dragged)
      .on('end', dragended))
;

  node.append('title')
    //.text(d => d.id);
    .text(d => d.description);


  if (data.nodes)
  text = svg.selectAll('.text')
    .data(data.nodes)
    .enter()
    .append('text')
    .attr('class', 'text')
    .text(d => d.id)
    .attr('font-size', 12)
    .attr('fill', 'black')
    .attr('x', d => d.x + nodeRadius + 5)
    .attr('y', d => d.y + nodeRadius + 5);


  simulation.on('tick', () => {
    link
      .attr('x1', d => d.source.x)
      .attr('y1', d => d.source.y)
      .attr('x2', d => d.target.x)
      .attr('y2', d => d.target.y);

    // Keep dragged nodes in place.
    //if (d3.event.active) 
    node.filter(d => d.isDragged)
    .each(d => {
        d.x = d3.event.x;
        d.y = d3.event.y;
        });

    node.filter(d=> !d.fixed)
      .attr("cx", d => {
            d.x = Math.max(nodeRadius, Math.min(containerWidth - nodeRadius, d.x? d.x: defaultX));
            return d.x;
        })
        .attr("cy", d => {
            d.y = Math.max(nodeRadius, Math.min(containerHeight - nodeRadius, d.y? d.y: defaultY));
            return d.y; 
        }
        );

    text
      .attr('x', d=> d.x? d.x:defaultX +nodeRadius)
      .attr('y', d=> d.y? d.x:defaultY +nodeRadius)
  });
}

function dblclick(d) {
  d.fixed = false; // unfix the node
}

const dragNode = d3.drag()
  .on('start', function(d) {
    d.isDragged = true;
  })
  .on('drag', function(d) {
    d.x = d3.event.x;
    d.y = d3.event.y;
  })
  .on('end', function(d) {
    d.isDragged = false;
  });

  function dragstarted(event) {
    if (!event.active && !d.fixed) 
        simulation.alphaTarget(0.3).restart();
    //event.subject.fx = event.subject.x;
    //event.subject.fy = event.subject.y;
    d.fx = d.x;
    d.fy = d.y;
    d.isDragged = true;
  }

  function dragged(event) {
    //event.subject.fx = event.x;
    //event.subject.fy = event.y;
    if (!d.fixed) {
        d.fx = d3.event.x;
        d.fy = d3.event.y;
    }
  }

  function dragended(event) {
    if (!event.active && !d.fixed) simulation.alphaTarget(0);
    event.subject.fx = null;
    event.subject.fy = null;
    d.isdragged = false;
  }


    // START HERE, making it look like example code for updatefdg
// // create the arrowhead markers
// svg.append("defs").selectAll("marker")
//   .data(["arrowhead"])
//   .enter().append("marker")
//   .attr("id", function(d) { return d; })
//   .attr("viewBox", "0 -5 10 10")
//   .attr("refX", nodeRadius + markerWidth + 10)
//   .attr("refY", 0)
//   .attr("markerWidth", markerWidth)
//   .attr("markerHeight", markerHeight)
//   .attr("orient", "auto")
//   .append("path")
//   .attr("d", "M0,-5L10,0L0,5");

function updateForceDirectedGraph(data) {
  // Update node, link, and label selections with new data
  if (data.nodes) node = node.data(data.nodes, d => d.id);
  if (data.links)
    link = link.data(data.links, d => 
        `${d.source.id? d.source.id: "nosource"}-${d.target.id? d.target.id: "notarget"}`);
  if (data.nodes) text = text.data(data.nodes, d => d.id);

  // Remove exiting elements
  if (node) node.exit().remove();
  if (link) link.exit().remove();
  if (text) text.exit().remove();


var newLink;
if (data.links) {
  newLink = 
 // svg.selectAll('.link')
 //   .data(data.links, d=>`${d.source.id}-${d.target.id }`);
  link.enter()
    .append('line')
    .attr('class', 'link')
    .attr('stroke', 'gray')
    .attr('stroke-width', d => Math.sqrt(d.value))
    .attr('marker-end', 'url(#arrowhead)') // add arrowhead to link
    //.attr("x1", function(d) { return d.source.x + nodeRadius; })
    //.attr("y1", function(d) { return d.source.y - nodeRadius; })
    //.attr("x2", function(d) { return d.target.x - nodeRadius; })
    //.attr("y2", function(d) { return d.target.y + nodeRadius; })
    ;
}

  const newNode = 
  //  svg.selectAll('.node')
  //  .data(data.nodes)
    node.enter()
    .append('g')
    .append('circle')
    .attr('class', 'node')
    .attr('r', nodeRadius)
    .attr('stroke', 'green') // add a visible outline
    .attr('stroke-width', 2) // specify the outline width
    //.attr('fill', d => `rgb(${d.group * 60}, 100, 200)`)
    //.attr('fill', d => `white`, 100, 200)
    .attr('fill', d => `rgba(255, 255, 255, 0.5`)
    //.call(dragNode)
    .on("dblclick", function(d) { // toggle freeze on double click
        d.fixed = !d.fixed;
        d3.select(this).classed("fixed", d.fixed);
        if (d.fixed) {
            d.fx = d.x;
            d.fy = d.y;
        } else {
            d.fx = null;
            d.fy = null;
        }
    })
    .call(d3.drag()
      .on('start', dragstarted)
      .on('drag', dragged)
      .on('end', dragended))
;

  newNode.append('title')
    //.text(d => d.id);
    .text(d => d.description);

  if (data.nodes) 
    text = svg.selectAll('.text')
    .data(data.nodes)

  const newText = 
  //svg.selectAll('.text')
  //  .data(data.nodes)
    text.enter()
    .append('text')
    .text(d => d.id)
    .attr('class', 'text')
    .attr('font-size', 12)
    .attr('fill', 'black')
    .attr('x', d => (isNaN(d.x) ? defaultX: d.x) + nodeRadius + 5)
    .attr('y', d => (isNaN(d.y) ? defaultY: d.y) + nodeRadius + 5);

if (node) node = newNode.merge(node);
if (link) link = newLink.merge(link);
if (text) text = newText.merge(text);

  // TODO repeated from create function; factor it out someday
  simulation.on('tick', () => {
    link
      .attr('x1', d => d.source.x)
      .attr('y1', d => d.source.y)
      .attr('x2', d => d.target.x)
      .attr('y2', d => d.target.y);

    //node
    //  .attr('cx', d => d.x)
    //  .attr('cy', d => d.y);
    
    // Keep dragged nodes in place.
    //if (d3.event.active) 
    node.filter(d => d.isDragged)
    .each(d => {
        d.x = d3.event.x;
        d.y = d3.event.y;
        });

    node.filter(d=> !d.fixed)
      .attr("cx", d => {
        d.x = Math.max(nodeRadius, Math.min(containerWidth - nodeRadius, d.x? d.x: defaultX));
        return d.x;
        })
        .attr("cy", d => {
        d.y = Math.max(nodeRadius, Math.min(containerHeight - nodeRadius, d.y? d.y: defaultY));
        return d.y; }
        );

    text
      .attr('x', d=> (isNaN(d.x)? defaultX:d.x) +nodeRadius)
      .attr('y', d=> (isNaN(d.y)? defaultY:d.y) +nodeRadius)
  });

  function dragstarted(event) {
    if (!event.active) simulation.alphaTarget(0.3).restart();
    event.subject.fx = event.subject.x;
    event.subject.fy = event.subject.y;
  }

  function dragged(event) {
    event.subject.fx = event.x;
    event.subject.fy = event.y;
  }

  function dragended(event) {
    if (!event.active) simulation.alphaTarget(0);
    event.subject.fx = null;
    event.subject.fy = null;
  }

// Restart simulation
  //simulation = d3.forceSimulation(data.nodes)
  simulation.nodes(data.nodes);
  simulation
    .force('link', d3.forceLink(data.links).id(d => d.id))
    //.force('charge', d3.forceManyBody().strength(50)) // add force to push nodes apart
    .force('charge', d3.forceManyBody().strength(-300)) // add force to push nodes apart
    .force('center', d3.forceCenter(width / 2, height / 2)) // center the graph
    .force('collide', d3.forceCollide().radius(function(d) { return d.radius + 50; })// add force to prevent circles from overlapping
    //.force('extent', d3.forceExtent([[0, 0], [width, height]]))
    .iterations(5)
    .strength(100)); 

  simulation.alpha(1).restart();
}

